// App.js
import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./component/Header";
import StudentHeader from './student/StudentHeader'; 
import Footer from "./component/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTopButton from "./pages/ScrollToTopButton";
import SplashScreen from "./component/SplashScreen";
import WhatsAppButton from "./component/WhatsappIntegration";
import { useAuth } from "./helpers/AuthContext";

const App = () => {
  const [showSplash, setShowSplash] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { studentId, logout } = useAuth();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  // Route checks
  const isInstructorRoute = location.pathname.startsWith("/instructor-panel");
  const isInstructorloginRoute = location.pathname === "/instructor-login";
  const ismobileVerification = location.pathname === "/instructor-verification";
  const isotpverfication = location.pathname === "/instructor-otp";
  const issignup = location.pathname === "/instructor-signup";
  const isinstructoraccessdenied = location.pathname === "/instructor-access-denied";
  const isinstructorfogotpassword = location.pathname === "/instructor-forgot-password";

  // Student route checks
  const isStudentloginRoute = location.pathname === "/student-login";
  const isStudentCreatePage = location.pathname === "/student-create";
  const isStudentRoute = location.pathname.startsWith("/student-panel");
  const isstudentmobileVerification = location.pathname === "/student-mobile-verification";
  const isstudentotpVerification = location.pathname === "/student-otp";
  const isStudentResetPassword = location.pathname === "/student-reset-password";

  // Admin route checks
  const isAdminRoute = location.pathname.startsWith("/admin-panel");
  const isadminlogin = location.pathname === "/admin-panel/admin-login";
  const isAssignmentPage = location.pathname.includes("/assignment-student/");

  // Public route check - EXCLUDE all auth pages
  const isPublicRoute =
    !isInstructorRoute &&
    !isInstructorloginRoute &&
    !isotpverfication &&
    !ismobileVerification &&
    !isinstructoraccessdenied &&
    !issignup &&
    !isStudentloginRoute &&
    !isStudentCreatePage &&
    !isstudentmobileVerification &&
    !isstudentotpVerification &&
    !isadminlogin &&
    !isAdminRoute &&
    !isStudentRoute &&
    !isinstructorfogotpassword &&
    !isStudentResetPassword;

  // Student Route Protection - FIXED
  useEffect(() => {
    // Only protect student-panel routes, not auth routes
    if (isStudentRoute && !studentId) {
      console.log("Unauthorized access to student panel. Redirecting to login.");
      logout();
      navigate("/student-login", { replace: true });
    }
  }, [isStudentRoute, studentId, navigate, logout]);

  // Apply theme to document on app load
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    const shouldBeDark = savedTheme === "dark";
    
    if (shouldBeDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, []);

  // Show Splash only on home page
  if (showSplash && location.pathname === "/") {
    return <SplashScreen onFinish={() => setShowSplash(false)} />;
  }

  // Determine which header to show
  const getHeader = () => {
    // Show no header on auth pages
    if (isStudentloginRoute || 
        isStudentCreatePage || 
        isstudentmobileVerification || 
        isstudentotpVerification ||
        isStudentResetPassword ||
        isInstructorloginRoute ||
        isadminlogin) {
      return null;
    }
    
    // // Show StudentHeader on student panel (when logged in and not assignment page)
    // if (isStudentRoute && studentId && !isAssignmentPage) {
    //   return <StudentHeader />;
    // }
    
    // Show public Header on public routes
    if (isPublicRoute) {
      return <Header />;
    }
    
    return null;
  };

  // Determine if footer should show
  const showFooter = isPublicRoute && 
    !isStudentloginRoute && 
    !isStudentCreatePage && 
    !isstudentmobileVerification && 
    !isstudentotpVerification &&
    !isStudentResetPassword;

  // Determine if WhatsApp button should show
  const showWhatsApp = isPublicRoute && 
    !isStudentloginRoute && 
    !isStudentCreatePage && 
    !isstudentmobileVerification && 
    !isstudentotpVerification &&
    !isStudentResetPassword;

  return (
    <div>
      <ToastContainer position="top-center" />
      <main>
        {getHeader()}
        <Outlet />
        {showFooter && <Footer />}
      </main>

      {showWhatsApp && <WhatsAppButton />}
    </div>
  );
};

export default App;